/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { createSelector } from '@reduxjs/toolkit';
import type { WarningModuleStore } from '../types';
import type { WarningsEventFormState } from './reducer';

const EMPTY_WARNINGS_EVENT_FORM_STATE: WarningsEventFormState = {};

export const selectWarningsEventFormState = (
  store: WarningModuleStore,
): WarningsEventFormState => {
  if (store?.warningsEventForm) {
    return store.warningsEventForm;
  }
  return EMPTY_WARNINGS_EVENT_FORM_STATE;
};

export const getWarningEvent = createSelector(
  selectWarningsEventFormState,
  (store) => store?.event,
);

export const getSelectedEventId = createSelector(
  selectWarningsEventFormState,
  (store) => store?.selectedEventId || '',
);

export const getWarningsEventIsFormDirty = createSelector(
  selectWarningsEventFormState,
  (store) => store?.isFormDirty || false,
);

export const getWarningsEventSelectedDrawing = createSelector(
  selectWarningsEventFormState,
  (store) => store?.selectedDrawing,
);

export const getWarningsEventHoveredDrawing = createSelector(
  selectWarningsEventFormState,
  (store) => store?.hoveredDrawing,
);
